import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Chip from "@mui/material/Chip";
import makeStyles from '@mui/styles/makeStyles';
import TextField from "@mui/material/TextField";
import Downshift from "downshift";

const useStyles = makeStyles(theme => ({
  chip: {
    margin: theme.spacing(0.5, 0.25)
  },
  tagField: {
    '& fieldset': {
      border: 'none'
    },
    '& .Mui-focused': {
      // borderColor: '#aebecd'
    },
  },
  filterField: {
    border: 'none !important',
    borderBottom: '1px solid rgba(0, 0, 0, 0.42) !important',
    borderRadius: "0px !important",
    marginTop: "10px",
    padding: '0 !important',
    flexWrap: 'wrap',
    '&:focus': {
      borderBottom: '1px solid #212a34 !important',
    },
    '&:hover': {
      borderBottom: '2px solid #212a34 !important',
    },
    '& input': {
      padding: '0 !important',
      // height: '20px !important'
    },
  },
  formControl: {
    border: "1px solid #aebecd",
    display: 'flex',
    flexWrap: 'wrap',
    paddingLeft: "0px",
    '&:focus': {
      border: '2px solid #035759 !important',
    },
  }
}));

function TagsInput({ ...props }) {
  const classes = useStyles();
  const { selectedTags, placeholder, tags, defaultValue, isFilterField, ...other } = props;
  const [inputValue, setInputValue] = React.useState("");
  const [selectedItem, setSelectedItem] = React.useState(defaultValue);
  useEffect(() => {
    setSelectedItem(tags);
  }, [tags]);
  useEffect(() => {
    if (selectedTags) {
      selectedTags(selectedItem);
    }
  }, [selectedItem, selectedTags]);

  useEffect(() => {
    setSelectedItem(defaultValue);
  }, [defaultValue]);


  function handleKeyDown(event) {
    if (event.key === "Enter") {
      const newSelectedItem = [...selectedItem];
      const duplicatedValues = newSelectedItem.indexOf(
        event.target.value.trim()
      );

      if (duplicatedValues !== -1) {
        setInputValue("");
        return;
      }
      if (!event.target.value.replace(/\s/g, "").length) return;

      newSelectedItem.push(event.target.value.trim());
      setSelectedItem(newSelectedItem);
      setInputValue("");
    }
    if (
      selectedItem.length &&
      !inputValue.length &&
      event.key === "Backspace"
    ) {
      setSelectedItem(selectedItem.slice(0, selectedItem.length - 1));
    }
  }
  function handleChange(item) {
    let newSelectedItem = [...selectedItem];
    if (newSelectedItem.indexOf(item) === -1) {
      newSelectedItem = [...newSelectedItem, item];
    }
    setInputValue("");
    setSelectedItem(newSelectedItem);
  }

  const handleDelete = item => () => {
    const newSelectedItem = [...selectedItem];
    newSelectedItem.splice(newSelectedItem.indexOf(item), 1);
    setSelectedItem(newSelectedItem);
  };

  function handleInputChange(event) {
    if (!/[^a-zA-Z0-9_]/.test(event.target.value)) {
      setInputValue(event.target.value);
    }
  }
  return (
    <React.Fragment>
      <Downshift
        id="downshift-multiple"
        inputValue={inputValue}
        onChange={handleChange}
        selectedItem={selectedItem}
      >
        {({ getInputProps }) => {
          const { onBlur, onChange, onFocus, ...inputProps } = getInputProps({
            onKeyDown: handleKeyDown,
            placeholder
          });
          return (
            <div>
              <TextField
                className={classes.tagField}
                InputProps={{
                  className: isFilterField ? `${classes.filterField} ${classes.formControl}` : `${classes.formControl}`,
                  startAdornment: selectedItem.map(item => (
                    <Chip
                      key={item}
                      tabIndex={-1}
                      size="small"
                      label={item}
                      className={classes.chip}
                      onDelete={handleDelete(item)}
                    />
                  )),
                  onBlur,
                  onChange: event => {
                    handleInputChange(event);
                    onChange(event);
                  },
                  onFocus
                }}
                {...other}
                {...inputProps}
              />
            </div>
          );
        }}
      </Downshift>
    </React.Fragment>
  );
}
TagsInput.defaultProps = {
  tags: [],
  defaultValue: []
};
TagsInput.propTypes = {
  selectedTags: PropTypes.func.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string)
};
export default TagsInput;
